import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import bg from 'assets/img/analyzers-bg.png';
import ia from 'assets/img/analyzers-ia.png';
import ic from 'assets/img/analyzers-ic.png';
import pa from 'assets/img/analyzers-pa.png';

import ia_ from 'assets/img/analyzers-circle-ia.png';
import ic_ from 'assets/img/analyzers-circle-ic.png';
import pe_ from 'assets/img/analyzers-circle-pe.png';

const Background = styled.div`
  text-align: center;
  color: #fff;
  width: 100%;
  height: 100%;
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: cover;
  border-radius: 0.25rem;
`;

export function AnalyzerCard({ imgSrc, title, description, onClick }) {
  return (
    <div class="tw-flex tw-items-center tw-space-x-6 tw-cursor-pointer hover:tw-underline" onClick={onClick}>
      <div class="tw-flex-shrink-0">
        <img className="tw-mx-auto tw-w-full tw-max-w-[220px] tw-max-h-[195px] tw-mb-2" src={imgSrc} alt="Discovery" />
      </div>
      <div>
        <h3 class="tw-text-2xl tw-font-semibold tw-text-gray-900 tw-mb-2">{title}</h3>
        <p class="tw-text-gray-600 tw-text-lg">{description}</p>
      </div>
    </div>
  );
}

function Analyzers({ session }) {
  const navigate = useNavigate();
  const { permissions } = session ?? {};

  return (
    <div class="tw-flex tw-flex-col tw-justify-center tw-p-8 tw-space-y-10 lg:tw-ml-14 ">
      {permissions.ia && (
        <AnalyzerCard
          title="Investment Analysis"
          description="Comprehensive quantitative risk analysis of a single asset."
          imgSrc={ia_}
          onClick={() => navigate({ pathname: '/ia', search: 'minass=true' }, { replace: false })}
        />
      )}

      {permissions.ic && (
        <AnalyzerCard
          title="Investment Comparison"
          description="Comprehensive quantitative risk analysis and comparison of multiple assets."
          imgSrc={ic_}
          onClick={() => navigate({ pathname: '/ic', search: 'multi=true&minass=true' }, { replace: false })}
        />
      )}

      {permissions.pa && (
        <AnalyzerCard
          title="Portfolio Engineer"
          description="Design, analyze and compare multi-asset portfolios."
          imgSrc={pe_}
          onClick={() => navigate({ pathname: '/pa' }, { replace: false })}
        />
      )}
    </div>
  );
}

export default Analyzers;
